import { Component } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-policy',
  templateUrl: './policy.component.html',
  styleUrls: ['./policy.component.scss'],
})
export class PolicyComponent {
  subscription!: Subscription;
  lang!: string;

  constructor(private translocoService: TranslocoService) {}

  ngOnInit(): void {
    this.subscription = this.translocoService.langChanges$.subscribe(
      (activeLang) => (this.lang = activeLang)
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
